import { Box } from '@nimbus-ds/components';
import { useResponsive } from 'commons/components';
import { BlockedAlert } from './components/BlockedAlert';
import { BlockedType } from '../enums';
import { useNuvemPagoBlocking } from '../hooks/useNuvemPagoBlocking';

export function BlockedAlertPage() {
  const { blockedTypes } = useNuvemPagoBlocking();
  const { isMobile } = useResponsive();

  const prioritizedBlockedType = blockedTypes.includes(
    BlockedType.NEGATIVE_BALANCE,
  )
    ? [BlockedType.NEGATIVE_BALANCE]
    : blockedTypes;

  return (
    <Box
      display="flex"
      flexDirection="column"
      backgroundColor={isMobile ? 'neutral-background' : undefined}
      minHeight="100vh"
      width="100%"
    >
      <Box
        display="flex"
        flexDirection="column"
        padding={isMobile ? '4' : '8'}
        width="100%"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          maxWidth={isMobile ? '100%' : '960px'}
          marginX="auto"
          width="100%"
          padding={isMobile ? '2' : '6'}
        >
          <Box display="flex" flexDirection="column" gap={isMobile ? '2' : '6'}>
            {prioritizedBlockedType.map((type) => (
              <BlockedAlert key={type} blockedType={type} />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default BlockedAlertPage;
